"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyController = function (_context) { return ({
    pageReady: function () { },
    exports: {}
}); };



//////////////////
// WEBPACK FOOTER
// ./viewer-script/controllers/emptyController.ts
// module id = 16
// module chunks = 0